// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"GettingStarted_Wrap__3eT4I","Description":"GettingStarted_Description__1QKn5","GettingStarted":"GettingStarted_GettingStarted__1SPOn"};